// extracted by mini-css-extract-plugin
export default {"container":"HelloUserCard_container__7zu6H","welcomeMessage":"HelloUserCard_welcomeMessage__JfDfC","today":"HelloUserCard_today__RvfVz"};